import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-login-acl-denied-modal',
  templateUrl: './login-acl-denied-modal.component.html',
  styleUrls: ['./login-acl-denied-modal.component.scss']
})
export class LoginAclDeniedModalComponent {
  constructor(
    public dialogRef: MatDialogRef<LoginAclDeniedModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  close() {
    this.dialogRef.close();
  }
}
